import { RowCustomAction } from '@msdk/common'
import {
  DefaultActionsDetails,
  Entity,
  EntityModel,
  RowActionBehaviour,
  RowActionsDefinition,
  ViewAcl,
  ViewModel,
} from '@msdk/definitions'

export function canEditRow(row: Entity, acl: ViewAcl, viewModel: ViewModel): boolean {
  return acl.canUpdate && row.canUpdate && viewModel.canEdit
}

export function canActivateRow(row: Entity, acl: ViewAcl): boolean {
  return row.fields['ENTITY_STATUS']?.value !== 'ACTIVE' && acl.canManageBin && row.canActivate
}

export function canDeactivateRow(row: Entity, acl: ViewAcl, model: EntityModel): boolean {
  return (
    row.fields['ENTITY_STATUS']?.value === 'ACTIVE' && model.canBeDeactivated && acl.canManageBin && row.canDeactivate
  )
}

export function canDeleteRow(row: Entity, acl: ViewAcl, model: EntityModel): boolean {
  return (
    row.fields['ENTITY_STATUS']?.value !== 'ACTIVE' &&
    model.canBeDeleted &&
    acl.canManageBin &&
    row.canDelete &&
    acl.canDelete
  )
}

export function hasCustomActions(actions: RowActionsDefinition['actions']): boolean {
  return actions && actions.length > 0
}

//cg is it possibile to remove it?
export function hasAvailableActions(
  row: Entity,
  rowActions: RowActionsDefinition,
  acl: ViewAcl,
  model: EntityModel,
  viewModel: ViewModel,
  actionInstances: Record<string, RowCustomAction>,
): boolean {
  const hasStandardActions =
    rowActions.behaviour === RowActionBehaviour.Standard &&
    (canEditRow(row, acl, viewModel) ||
      canActivateRow(row, acl) ||
      canDeactivateRow(row, acl, model) ||
      canDeleteRow(row, acl, model))
  const hasACustomActions = hasCustomActions(rowActions.actions)
  return hasStandardActions || hasACustomActions
}

export function renderDefaultActions(
  incomingDefaultActions: DefaultActionsDetails[],
  actions: any,
): React.JSX.Element[] {
  return incomingDefaultActions
    .map((item) => {
      const action = actions.find((a: any) => a.type === item.type)
      if (!action || !action.visible) return null
      return {
        component: action.component,
      }
    })
    .filter(Boolean)
    .map((action) => action?.component)
}
